import { render, staticRenderFns } from "./TransactionModal.vue?vue&type=template&id=05a4919a&scoped=true"
import script from "./TransactionModal.vue?vue&type=script&lang=js"
export * from "./TransactionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a4919a",
  null
  
)

export default component.exports